var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { logger } from '@amzn/atoz-shiftapp-metrics';
import merge from 'deepmerge';
import { resources as english } from './assets/translations/atozshiftapp-en-US.puff.json';
import { resources as clockLocalesEnglish } from '@atoz/gps-clock-punch/dist/translations/atozgpsclockpunch-en-US.puff.json';
import { resources as taaComponentsEnglish } from '@amzn/atoz-dashboard-taa-components/dist/assets/locales/panther/atozdashboardtaacomponents.puff.json';
import { default as dayOneWidgetEnglish } from '@amzn/atozmobile-tenant-day-one-info/dist/locales/en-US.json';
var AtoZI18NextBackend = /** @class */ (function () {
    function AtoZI18NextBackend() {
        this.type = 'backend';
    }
    AtoZI18NextBackend.resolveLocale = function (language, allowedLocales) {
        // check if the locale is valid
        if (allowedLocales.has(language)) {
            return language;
        }
        // remove the locale and use language only
        var languageOnly = language.split('-')[0];
        if (allowedLocales.has(languageOnly)) {
            return languageOnly;
        }
        // attempt to use the default locale for specified language
        if (AtoZI18NextBackend.defaultLocaleMap.has(languageOnly)) {
            var languageAndLocale = 
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            AtoZI18NextBackend.defaultLocaleMap.get(languageOnly);
            if (allowedLocales.has(languageAndLocale)) {
                return languageAndLocale;
            }
        }
        // immediately fall back to en-US
        return 'en-US';
    };
    AtoZI18NextBackend.prototype.init = function () {
        /* no-op */
    };
    AtoZI18NextBackend.prototype.create = function () {
        /* no-op */
    };
    AtoZI18NextBackend.prototype.read = function (language, namespace, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var appTranslations, data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.loadAppTranslations(language, namespace)];
                    case 1:
                        appTranslations = _a.sent();
                        this.logIfDifferentLocale(language, namespace, __assign({}, appTranslations.resolvedTo));
                        data = __assign({}, appTranslations.data);
                        callback(null, data);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        // this should not occur unless we were totally unable to import the file
                        logger.emitError('Unable to load locale', {
                            error: new Error(err_1),
                            context: {
                                language: language,
                                namespace: namespace
                            }
                        });
                        callback(err_1, {});
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AtoZI18NextBackend.prototype.loadAppTranslations = function (locale, namespace) {
        return __awaiter(this, void 0, void 0, function () {
            var normalizedLocale, app, smaResources, taaResources, localizedPayCodes, dayOneResources, resources;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        normalizedLocale = AtoZI18NextBackend.resolveLocale(locale, AtoZI18NextBackend.baseAllowedLocales);
                        app = AtoZI18NextBackend.APP_RESOURCE;
                        return [4 /*yield*/, import(
                            /*
                            webpackChunkName: "locale.[request]"
                            */
                            "./assets/translations/".concat(app, "-").concat(normalizedLocale, ".puff.json")).then(function (_a) {
                                var translations = _a.default;
                                smaResources = translations;
                            })];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, import(
                            /*
                            webpackChunkName: "locale.[request]"
                            */
                            "@amzn/atoz-dashboard-taa-components/dist/assets/translations/atozdashboardtaacomponents-".concat(normalizedLocale, ".puff.json")).then(function (_a) {
                                var translations = _a.default;
                                taaResources = translations;
                            })];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, import(
                            /*
                            webpackChunkName: "locale.[request]"
                            */
                            "@amzn/atoz-dashboard-taa-components/dist/assets/locales/localizedPayCodes/".concat(normalizedLocale, ".puff.json"))
                                .then(function (_a) {
                                var translations = _a.default;
                                localizedPayCodes = translations;
                            })
                                .catch(function () {
                                localizedPayCodes = {};
                            })];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, import(
                            /*
                            webpackChunkName: "locale.[request]"
                            */
                            "@amzn/atozmobile-tenant-day-one-info/dist/locales/".concat(normalizedLocale, ".json")).then(function (_a) {
                                var translations = _a.default;
                                dayOneResources = { resources: translations };
                            })];
                    case 4:
                        _b.sent();
                        resources = merge.all([
                            smaResources,
                            taaResources,
                            localizedPayCodes,
                            dayOneResources
                        ]);
                        return [2 /*return*/, {
                                data: resources ? resources[namespace] : {},
                                resolvedTo: (_a = {}, _a[app] = normalizedLocale, _a)
                            }];
                }
            });
        });
    };
    AtoZI18NextBackend.prototype.logIfDifferentLocale = function (language, namespace, resolvedTo) {
        var diffs = {};
        for (var _i = 0, _a = Object.keys(resolvedTo); _i < _a.length; _i++) {
            var resource = _a[_i];
            if (resolvedTo[resource] !== language) {
                diffs[resource] = resolvedTo[resource];
            }
        }
        if (Object.keys(diffs).length > 0) {
            logger.info('Resolved a different language and locale than requested', {
                requested: language,
                resolvedTo: diffs,
                namespace: namespace
            });
        }
    };
    // Weave your resource in here, this is the initial hydration
    AtoZI18NextBackend.ALL_ENGLISH_RESOURCES = {
        resources: __assign(__assign(__assign(__assign({}, english), clockLocalesEnglish), taaComponentsEnglish), dayOneWidgetEnglish)
    };
    AtoZI18NextBackend.baseAllowedLocales = new Set([
        'ar-AE',
        'ar-SA',
        'bn-IN',
        'cs-CZ',
        'de-DE',
        'en-AE',
        'en-AU',
        'en-CA',
        'en-GB',
        'en-IN',
        'en-SG',
        'en-US',
        'es-AR',
        'es-CL',
        'es-CO',
        'es-ES',
        'es-MX',
        'es-US',
        'fr-CA',
        'fr-FR',
        'gu-IN',
        'he-IL',
        'hu-HU',
        'it-IT',
        'ja-JP',
        'kn-IN',
        'ko-KR',
        'lt-LT',
        'ml-IN',
        'mr-IN',
        'my-MM',
        'ne-NP',
        'nl-NL',
        'pl-PL',
        'pt-BR',
        'pt-PT',
        'ro-RO',
        'ru-RU',
        'sk-SK',
        'so-SO',
        'sv-SE',
        'ta-IN',
        'te-IN',
        'tl-PH',
        'tr-TR',
        'uk-UA',
        'zh-CN',
        'zh-TW'
    ]);
    AtoZI18NextBackend.defaultLocaleMap = new Map([
        ['ar', 'ar-AE'],
        ['bn', 'bn-IN'],
        ['cs', 'cs-CZ'],
        ['de', 'de-DE'],
        ['en', 'en-US'],
        ['es', 'es-ES'],
        ['fr', 'fr-FR'],
        ['gu', 'gu-IN'],
        ['he', 'he-IL'],
        ['hi', 'hi-IN'],
        ['hu', 'hu-HU'],
        ['it', 'it-IT'],
        ['ja', 'ja-JP'],
        ['kn', 'kn-IN'],
        ['ko', 'ko-KR'],
        ['lt', 'lt-LT'],
        ['ml', 'ml-IN'],
        ['mr', 'mr-IN'],
        ['my', 'my-MM'],
        ['ne', 'ne-NP'],
        ['nl', 'nl-NL'],
        ['pl', 'pl-PL'],
        ['pt', 'pt-PT'],
        ['ro', 'ro-RO'],
        ['ru', 'ru-RU'],
        ['sk', 'sk-SK'],
        ['so', 'so-SO'],
        ['sv', 'sv-SE'],
        ['ta', 'ta-IN'],
        ['te', 'te-IN'],
        ['tl', 'tl-PH'],
        ['tr', 'tr-TR'],
        ['uk', 'uk-UA'],
        ['zh', 'zh-CN']
    ]);
    AtoZI18NextBackend.APP_RESOURCE = 'atozshiftapp';
    return AtoZI18NextBackend;
}());
export { AtoZI18NextBackend };
